import { render, staticRenderFns } from "./ClubLayout.vue?vue&type=template&id=8a36a136&scoped=true&"
import script from "./ClubLayout.vue?vue&type=script&lang=js&"
export * from "./ClubLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClubLayout.vue?vue&type=style&index=0&id=8a36a136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a36a136",
  null
  
)

export default component.exports